const mask = {
	namespaced: true,
	state: {
		// 是否显示遮罩
		isShowMask: false,
		// 并发请求计数器，解决多接口同时请求遮罩提前消失
		loadingNum: 0
	},
	mutations: {
		// 发起请求：计数+1，打开遮罩
		addLoading(state) {
			state.loadingNum++
			state.isShowMask = true
		},
		// 请求结束/报错：计数-1，归零关闭遮罩
		reduceLoading(state) {
			state.loadingNum--
			// 防止负数
			if (state.loadingNum <= 0) {
				state.loadingNum = 0
				state.isShowMask = false
			}
		},
		// 手动强制关闭遮罩（路由切换用）
		closeAllMask(state) {
			state.loadingNum = 0
			state.isShowMask = false
		}
	},
	actions: {
		// 开启loading
		startLoading({
			commit
		}) {
			commit('addLoading')
		},
		// 关闭loading
		endLoading({
			commit
		}) {
			commit('reduceLoading')
		},
		// 清空全部loading（切页面）
		clearAllLoading({
			commit
		}) {
			commit('closeAllMask')
		}
	}
}



export default mask